import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const failedComplaint = createAction(ACTION.FAILED_COMPLAINT.REQUEST, (id, input) => ({id, input}));
export const resetParamError = createAction(ACTION.RESET_PARAM_ERROR, (id, param) => ({id, param}));
export const clearState = createAction(ACTION.CLEAR_STATE, id => ({id}));
